<template>
  <div class="base-box">
    <div class="content">
      <div class="content-header">
        <div class="content-title">{{ listTitle }}</div>
        <el-divider id="divider3"></el-divider>
        <div class="content-subtitle">
          articles
        </div>
      </div>
      <ul v-for="item in listContent" :key="item.id">
        <li>
          <a :href="listUrl + item.id">{{ item.title }}</a>
        </li>
      </ul>

      <el-pagination
        small
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :page-size="8"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCard",
  props: ["listTitle", "listContent", "listUrl", "total"],
  created() {},

  methods: {
    handleCurrentChange(val) {
      this.$emit("currentPageChange", val);
    }
  }
};
</script>

<style scoped>
.base-box {
  position: relative;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background-color: #97b9ff;
  float: left;
  width: 275px;
  min-height: 802px;
}
.content {
  text-align: center;
}
ul {
  padding: 0;
}
ul li a {
  text-decoration: none;
  color: rgb(48, 47, 47);
}

ul li {
  list-style-type: none;
  text-align: left;
  padding-left: 20px;
}

.content-header {
  padding: 20px 10px;
  background-color: #4079f1;
}

.content-title {
  color: white;
  margin: 0;
  text-align: left;
  font-size: 24px;
}

.content-subtitle {
  color: white;
  font-size: 16px;
  text-align: right;
}

.el-divider {
  margin: 5px 0 0 0;
}
.el-pagination .is-background {
  background-color: green;
}
</style>

<style>
.el-pagination.is-background .el-pager > li {
  /*对页数的样式进行修改*/
  background: transparent;
  color: #fff;
}
.el-pagination.is-background .btn-next {
  /*对下一页的按钮样式进行修改*/
  background: transparent;
  color: #fff;
}
.el-pagination.is-background .btn-prev {
  /*对上一页的按钮样式进行修改*/
  background: transparent;
  color: #fff;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  /*当前选中页数的样式进行修改*/
  background: transparent;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseCard.vue